module.exports = __webpack_public_path__ + "img/no-see.78caa467.svg";